import { usePreservedCallback } from '@toss/react';
import { useStore } from 'jotai';

import { fillSlotAtom } from '../features/question-card-ai/stores/questionCardAi.atoms';
import { useBuildFormContext } from '../form/schema';
import { pendingImageUploadIdsAtom } from '../stores/imageUpload.atoms';

import { getEmptyAnswerInputCleanups } from './getEmptyAnswerInputCleanups';

export const useRemoveEmptyAnswerInputs = () => {
  const { getValues, setValue } = useBuildFormContext();
  const store = useStore();

  return usePreservedCallback(() => {
    const aiFillingIds = Object.values(store.get(fillSlotAtom)).flatMap(slot =>
      slot.status === 'running' ? slot.slotIds ?? [] : [],
    );
    const result = getEmptyAnswerInputCleanups(getValues('quizList'), {
      pendingItemIds: new Set([
        ...store.get(pendingImageUploadIdsAtom),
        ...aiFillingIds,
      ]),
    });

    result.cleanups.forEach(({ quizIndex, writes }) => {
      writes.forEach(({ path, value }) => {
        setValue(`quizList.${quizIndex}.${path}`, value, { shouldDirty: true });
      });
    });

    return result;
  });
};
